import * as React from 'react';

import { useTranslation } from 'react-i18next';
import { CdnIcon } from '@shared/ui';

import { useTheme } from '../../../../theme';
import { DocumentInfoCard } from '../../../../InfoCard/types';

interface Props {
	document: DocumentInfoCard;
	index: number;
	docTypeLabel: string;
	citizenshipLabel?: string;
	onEdit: (index: number) => void;
	onRemove?: (index: number) => void;
}

const DocumentCard: React.FC<Props> = ({ document, index, docTypeLabel, citizenshipLabel, onEdit, onRemove }) => {
	const { DocumentCard: css } = useTheme('TravellerForm');
	const { t: tTraveller } = useTranslation('Traveller');

	const details = [document.docNumber, document.docExpiryDate].filter(Boolean).join(', ');

	return (
		<div className={css.documentCard}>
			<div className={css.documentCard__icon}>
				<CdnIcon icon="Document/Passport" />
			</div>

			<div className={css.documentCard__info}>
				<div className={css.documentCard__type}>{docTypeLabel}</div>
				{citizenshipLabel && <div className={css.documentCard__details}>{citizenshipLabel}</div>}
				{details && <div className={css.documentCard__details}>{details}</div>}
				<div className={css.documentCard__edit} onClick={() => onEdit(index)}>
					{tTraveller('Edit')}
				</div>
			</div>

			{onRemove && (
				<div className={css.documentCard__remove} onClick={() => onRemove(index)}>
					<CdnIcon icon="Action/Remove" />
				</div>
			)}
		</div>
	);
};

export default DocumentCard;
